'use client';

import { Web3Provider as LFGWeb3Provider } from '@lfg/core/providers/Web3Provider';
import { QueryClient } from '@tanstack/react-query';
import { PropsWithChildren } from 'react';
import { cookieToInitialState } from 'wagmi';

import { wagmiConfig } from '@/global/configs/wagmi.config';

export interface Web3ProviderProps {
  cookie?: string | null;
}

export const Web3Provider = ({ cookie, children }: PropsWithChildren<Web3ProviderProps>) => {
  const query = new QueryClient();
  const appInfo = { appName: 'NODE_SALE' };
  const initialState = cookieToInitialState(wagmiConfig, cookie);

  return (
    <LFGWeb3Provider
      queryClient={query}
      rainbowKitProps={{ appInfo }}
      wagmiConfig={wagmiConfig}
      wagmiProps={{ initialState }}>
      {children}
    </LFGWeb3Provider>
  );
};
